import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { RegistrationSchema } from 'app/campaign/structure/event-page';
import { CampaignService } from '../../../campaign/services/campaign.service';
import { Store } from '@ngrx/store';
import { removeRegistration } from 'app/event/features/event.actions';
import * as DialogActions from '../../../dialog/features/dialog.actions';
import { TransformService } from 'app/core/services/transform.service';

@Component({
  selector: 'app-registration-button',
  templateUrl: './registration-button.component.html',
  styleUrl: './registration-button.component.scss'
})
export class RegistrationButtonComponent implements OnInit{

  private _registration = null;
  
  @Input()  
  set registration(registration) {
    this._registration = this.transformService.transform(registration);
  }
  get registration() {
    return this._registration;
  }

  @Input() index = null;
  @Input() eventPageId = null;

  public button: UntypedFormGroup = null;

  constructor(
    public store: Store,
    public formBuilder: UntypedFormBuilder,
    public campaignService: CampaignService,
    private transformService: TransformService
  ) {}

  ngOnInit() {
    this.button = this.formBuilder.group({});
    this.campaignService.generateForm(this.button, RegistrationSchema);
  }

  editRegistrationButton(option, index) {
    const action = DialogActions.openDialog({
      payload: {
        name: 'registrationButtonForm',
        options: {
          size: 'default',
          modalClass:'modal--paybee',
          containerClass:'mdb-modal-backdrop-paybee',
          ignoreBackdropClick: true
        },
        initialState: {id: index, action: 'edit', option}
      }
    });
    this.store.dispatch(action);
  }

  removeOption(eventPageRegistrationId) {
    this.store.dispatch({
      type: removeRegistration.type,
      payload: {
        eventPageId: this.eventPageId,
        eventPageRegistrationId
      }
    });
  }
}
